import React from 'react';
import {classNames} from '@utils/class-names';
import {SpecialistSearchResultDto} from "../../core/models/interfaces/specialists-search-result-dto.interface";
import SpecialistCard from './specialist-card';
import {UniversalClickHandler} from "@common/models/types/universal-click-handler.type";

interface SpecialistListProps {
    specialists: SpecialistSearchResultDto[];
    className?: string;
    onClick?: UniversalClickHandler<void, SpecialistSearchResultDto>;
    showActionsCard?: boolean;
    isSpecialistSelected?: (specialistId: string) => boolean;
    isLoadingMore?: boolean;
    onSuccessDelete?: UniversalClickHandler<void, string>;
}

const SpecialistList: React.FC<SpecialistListProps> = (props: SpecialistListProps) => {
    const {
        specialists,
        className = '',
        onClick,
        showActionsCard,
        isSpecialistSelected,
        isLoadingMore = false,
        onSuccessDelete
    } = props;

    return (
        <div className={classNames('space-y-4', className)}>
            {specialists.map((specialist) => (
                <SpecialistCard
                    key={specialist.id}
                    specialist={specialist}
                    onClick={onClick}
                    showActions={showActionsCard}
                    onSuccessDelete={onSuccessDelete}
                    isSelected={isSpecialistSelected?.(specialist.id)}
                />
            ))}

            {isLoadingMore && (
                <div className="flex items-center justify-center py-4 text-on-surface/60">
                    <div className="h-5 w-5 mr-2 rounded-full border-2 border-outline-mild border-t-primary animate-spin"/>
                    <span>Ładowanie...</span>
                </div>
            )}
        </div>
    );
};

export default SpecialistList;
